/* eslint-disable no-unused-vars */
import React from "react";
import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import { FirstName, LastName } from "../../utils/getName";

import "./About.css";

import profile from "../../assets/profile.png";

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: "100vw",
    marginTop: "3em",
    marginBottom: "auto",
  },
}));

export const About = () => {
  const classes = useStyles();
  const greetings = "Hey...!";
  const aboutme = `I'm ${FirstName} ${LastName}, Experienced Full Stack Web Developer adept in React, Node.js, Express.js, MongoDB, HTML, and CSS. Possessing 1 year of hands-on experience, specializes in crafting robust web applications with a focus on user-centric design and functionality. Previously demonstrated proficiency in unit testing methodologies using Jest and React Testing Library, ensuring code quality and reliability. Driven by a passion for leveraging cutting-edge technologies to propel innovation and deliver exceptional digital solutions.`;

  return (
    <section id="about">
      <Container component="main" className={classes.main} maxWidth="md">
        <h1 style={{ textAlign: "center", padding: "20px", fontSize: "3rem" }}>
          About Me
        </h1>
        <div className="about">
          <div
            className="_img"
            style={{
              background: "url(" + profile + ")",
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="_content_wrapper">
            <Typography component="h2" variant="h5">
              <TextDecrypt text={`${greetings}`} />
            </Typography>
            <p className="aboutme">{aboutme}</p>
            <a href="#contact" className="contact-btn">
              <i className="fas fa-terminal"></i>
              <Typography component="span"> Send me a message.</Typography>
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};
